globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Statistics = appCustomerSpace.Controllers.Statistics || {};

appCustomerSpace.Controllers.Statistics.ConversionsController = (function(superClass) {

  utils.extend(ConversionsController, superClass);

  function ConversionsController() {
    return ConversionsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(ConversionsController.prototype, {
    init: function(){
      new appCustomerSpace.Modules.Statistics();

      return ConversionsController.__super__.init.apply(this, arguments);
    },
  });

  return ConversionsController;
})(appCustomerSpace.Controllers.Statistics.MainController);
